// extracted by mini-css-extract-plugin
export default {"table":"AccountList_table__s6Iuw"};